import React from 'react';
import ReactDOM from 'react-dom';
import angular from 'angular';
import { components as Core } from '../../core';
import { SelfPublisherError } from '../components';
export default angular
    .module('doxy.call.provider-self-publisher-error', [])
    .component('callSelfPublisherError', {
    template: '<div></div>',
    bindings: {
        variant: '<',
    },
    controller: function ($element) {
        this.$onInit = () => {
            ReactDOM.render(React.createElement(Core.withProviders(SelfPublisherError), {
                variant: this.variant,
            }), $element[0]);
        };
    },
}).name;
